/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { DefaultPage } from '../templates/DefaultPage';
import { StyledContentWrapper } from '../atoms/StyledContentWrapper';
import { StyledContent } from '../atoms/StyledContent';
import { Heading1, RegularText } from '../atoms/StyledTypography';
import { StyledVerticalFlow } from '../atoms/StyledVerticalFlow';
import { StyledButtonSubmit } from '../atoms/StyledButtonSubmit';
import { TextField } from '../molecules/TextField';
import { TextareaField } from '../molecules/TextareaField';
import { ContentIcon } from '../molecules/ContentIcon';
import { IconMail } from '../atoms/IconMail';
import { IconMailSent } from '../atoms/IconMailSent';
import { MessageWithIcon } from '../molecules/MessageWithIcon'
import { IconRobot } from '../atoms/IconRobot'


/*********************************************************************************
 2. Component
 *********************************************************************************/

export class Contact extends Component {
    constructor() {
        super();

        this.state = {
            name: '',
            email: '',
            message: '',
            valid: false,
            sending: false,
            submitted: false,
            responseError: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            valid: this.form.checkValidity()
        });
    }

    handleSubmit(event) {

        event.preventDefault();

        this.setState({
            sending: true,
            responseError: false
        });

        const { name, email, message } = this.state;

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/support/contact`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name,
                email,
                message
            })
        }).then((res) => {
            if (res.status !== 204) {
                throw new Error(res.statusText);
            }
            this.setState({
                submitted: true,
                sending: false
            });
        }).catch(() => {
            this.setState({
                sending: false,
                responseError: true
            });
        });
    }

    render() {
        return (
            <DefaultPage>
                <Helmet title="Contact Us | Price Paid Data"/>
                <StyledContentWrapper>
                    {!this.state.submitted ? (
                        <StyledContent>
                            <StyledVerticalFlow>
                                <Heading1>Get in touch</Heading1>
                            </StyledVerticalFlow>
                            <StyledVerticalFlow>
                                <RegularText>Whether you have a question about how Price Paid Data works, need
                                    assistance using the app or you simply want to say hi - We’re here for
                                    you!</RegularText>
                            </StyledVerticalFlow>
                            <StyledVerticalFlow>
                                <form onSubmit={this.handleSubmit} ref={(form) => {
                                    this.form = form;
                                }}>
                                    <StyledVerticalFlow>
                                        <TextField type="text" label="Your name" id="name" name="name"
                                                   placeholder="John Smith" value={this.state.name}
                                                   onChange={this.handleInputChange} required/>
                                    </StyledVerticalFlow>
                                    <StyledVerticalFlow>
                                        <TextField type="email" label="Your email address" id="email" name="email"
                                                   placeholder="you@example.com" value={this.state.email}
                                                   onChange={this.handleInputChange} required/>
                                    </StyledVerticalFlow>
                                    <StyledVerticalFlow>
                                        <TextareaField label="How can we help?" id="message" name="message"
                                                       value={this.state.message} onChange={this.handleInputChange}
                                                       placeholder="Your message" required/>
                                    </StyledVerticalFlow>
                                    <StyledVerticalFlow>
                                        <StyledButtonSubmit type="submit" sending={this.state.sending}
                                                            disabled={!this.state.valid}>Send</StyledButtonSubmit>
                                    </StyledVerticalFlow>
                                    {this.state.responseError &&
                                    <StyledVerticalFlow>
                                        <MessageWithIcon icon={<IconRobot/>}>
                                            Oh no! There was an error sending your message.
                                            We'll look into it right away!
                                        </MessageWithIcon>
                                    </StyledVerticalFlow>
                                    }
                                </form>
                            </StyledVerticalFlow>
                            <ContentIcon icon={<IconMail/>}/>
                        </StyledContent>
                    ) : (
                        <StyledContent>
                            <StyledVerticalFlow>
                                <Heading1>Thanks</Heading1>
                            </StyledVerticalFlow>
                            <StyledVerticalFlow>
                                <RegularText>Thanks for getting in touch! We appreciate you contacting us and we'll
                                    try to respond as soon as possible. Have a great day!</RegularText>
                            </StyledVerticalFlow>
                            <ContentIcon icon={<IconMailSent/>}/>
                        </StyledContent>
                    )}
                </StyledContentWrapper>
            </DefaultPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/Contact.js